/* CALL 上端プログレスバー。
   1. サイト内リンクのクリック / フォーム送信で開始(sessionStorage に印を残す)
   2. 次のページでは印があれば途中から始め、DOMContentLoaded で 100% → 消える
   3. 戻る/進む(bfcache 復帰)では出さない */
(function () {
  'use strict';
  var root = document.querySelector('[data-cec-progress]');
  if (!root) return;
  var KEY = 'cec-progress';

  /* 中央の丸ゲージ(試作): 待ちが delay ms を超えた時だけ出す。delay=0 なら無効 */
  var ring = document.querySelector('[data-cec-ring]');
  var ringDelay = parseInt(root.getAttribute('data-cec-ring-delay') || '0', 10) || 0;
  var ringTimer = null;
  function ringArm() {
    if (!ring || !ringDelay) return;
    ringDisarm();
    ringTimer = window.setTimeout(function () { ring.classList.add('is-active'); }, ringDelay);
  }
  function ringDisarm() {
    if (ringTimer) { window.clearTimeout(ringTimer); ringTimer = null; }
    if (ring) ring.classList.remove('is-active');
  }

  function start() { root.classList.remove('is-done'); root.classList.add('is-active'); ringArm(); }
  function finish() {
    ringDisarm();
    if (!root.classList.contains('is-active')) return;
    root.classList.add('is-done');
    window.setTimeout(function () {
      root.classList.remove('is-active');
      window.setTimeout(function () { root.classList.remove('is-done'); }, 300);
    }, 220);
  }
  function mark() { try { sessionStorage.setItem(KEY, '1'); } catch (e) {} }
  function consume() {
    var v = null;
    try { v = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); } catch (e) {}
    return v === '1';
  }

  /* 前のページで押されて来たなら、途中から続きを出す */
  if (consume()) {
    start();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', finish);
    } else {
      finish();
    }
  }

  /* サイト内リンクだけ。新規タブ・修飾キー・ページ内リンク・ダウンロード・ドロワー開閉は対象外 */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a[href]');
    if (!a) return;
    if (a.target && a.target !== '_self') return;
    if (a.hasAttribute('download')) return;
    /* ドロワーを開くだけのリンクは遷移しない(ヘッダーのカート、下部ナビの商品など)。
       テーマの drawer-opener は click を止めるので、読み込み表示を出すと消えなくなる */
    if (a.closest('drawer-opener:not([data-disabled="true"])')) return;
    if (a.hasAttribute('data-cec-open')) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(href)) return;
    var url;
    try { url = new URL(a.href, location.href); } catch (err) { return; }
    if (url.origin !== location.origin) return;
    if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
    start();
    mark();
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.target === '_blank' || f.hasAttribute('data-ajax')) return;
    start();
    mark();
  }, true);

  /* 戻る/進むでキャッシュから復帰した時は消す */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      ringDisarm();
      root.classList.remove('is-active', 'is-done');
      try { sessionStorage.removeItem(KEY); } catch (err) {}
    }
  });
})();
